import React from 'react';
import { DotsSixVertical } from '@phosphor-icons/react';
import { CrmField } from '../DraggableCrmField';

interface DraggableFieldOverlayProps {
  field: CrmField;
}

export const DraggableFieldOverlay: React.FC<DraggableFieldOverlayProps> = ({
  field,
}) => {
  return (
    <div className="flex items-center gap-3 p-3 bg-neutral-0 border border-primary-400 rounded-lg shadow-xl cursor-grabbing rotate-2 scale-105">
      <DotsSixVertical size={16} className="text-neutral-400 shrink-0" />
      <div className="flex flex-col min-w-0">
        <span className="font-medium text-sm text-neutral-700 truncate">
          {field.label}
        </span>
      </div>
    </div>
  );
};
